import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=3f76d83c&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=js&"
export * from "./InputFile.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-file.scss?vue&type=style&index=0&id=3f76d83c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76d83c",
  null
  
)

export default component.exports